<div class="d-flex justify-content-center align-items-center py-4" style="height: 100vh;">

  <div class="col-md-4 col-sm-6 login-form shadow py-5 rounded bg-white">

    <p class="text-center f18 text-secondary mb-1">تغییر رمز عبور</p>

    <ng-container *ngIf="ForceChangePass">

      <p class="text-center f14 text-danger px-4"> برای ادامه استفاده از سیستم، تغییر رمز عبور الزامی است </p>

    </ng-container>

    <div class="col-9 mt-2 mx-auto" [formGroup]="ChangePassModel">
      <div class="input-group mb-3  ">

        <input class="form-control bg-gray  text-start radios-left" formControlName="strPassword"
          placeholder="کلمه عبور فعلی" [type]="password ? 'text' : 'password'">
        <span class="input-group-text bg-gray radios-right" (click)="changeType()">
          <i class="fa fa-eye-slash " *ngIf="!password" style="cursor: pointer"></i>
          <i class="fa fa-eye " *ngIf="password" style="cursor: pointer"></i>
        </span>
      </div>
      <div class="input-group mb-3  ">

        <input class="form-control bg-gray  text-start radios-left" formControlName="strPassword2"
          placeholder="کلمه عبور جدید" [type]="password2 ? 'text' : 'password'">
        <span class="input-group-text bg-gray radios-right" (click)="changeType2()">
          <i class="fa fa-eye-slash " *ngIf="!password2" style="cursor: pointer"></i>
          <i class="fa fa-eye " *ngIf="password2" style="cursor: pointer"></i>
        </span>
      </div>
      <div class="input-group mb-3  ">

        <input class="form-control bg-gray  text-start radios-left" formControlName="strPasswordNew"
          placeholder="تکرار کلمه عبور جدید" [type]="password3 ? 'text' : 'password'">
        <span class="input-group-text bg-gray radios-right" (click)="changeType3()">
          <i class="fa fa-eye-slash " *ngIf="!password3" style="cursor: pointer"></i>
          <i class="fa fa-eye " *ngIf="password3" style="cursor: pointer"></i>
        </span>
      </div>
    </div>

    <div class="d-flex align-items-center mt-3 flex-column mb-2">

      <button class="btn btn-success d-flex col-9 align-items-center  justify-content-center mb-3"
        (click)="changePass()"><span>تغییر کلمه عبور</span> <i class="fa fa-check-circle px-2"></i></button>

      <ng-container *ngIf="!ForceChangePass">

        <button class="btn btn-warning d-flex col-9 align-items-center  justify-content-center mb-3"
          [routerLink]="['/']">

          برگشت

        </button>

      </ng-container>


    </div>

  </div>

</div>